const hasReducedMotionDisabled = '(prefers-reduced-motion: reduce)';
const isHoverableDevice = '(hover: hover) and (pointer: fine)';

export const UserSettingsQueries = {
  hasReducedMotionDisabled,
  isHoverableDevice
};
